import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';

// get messages for default language
import { messages } from '../../locales/de/messages';

export const defaultLocale = 'en';
export const ThemeContext = React.createContext({
  language: 'en',
  toggleLanguage: () => ({})
});

i18n.load(defaultLocale, messages);
i18n.activate(defaultLocale);

/**
* @param locale any locale string
*/
async function dynamicActivate(locale: string): Promise<void> {
  const { messages } = await import(`../../locales/${locale}/messages`);
  i18n.load(locale, messages);
  i18n.activate(locale);
}

export const LanguageDetection = (props: { children: any; }) => {
  const { locale } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (locale !== undefined) {
      if (['en', 'de'].includes(locale)) {
        dynamicActivate(locale);
      } else {
        dynamicActivate(defaultLocale)
        navigate('/en');
      }
    }
  }, [locale, navigate]);

  return <I18nProvider i18n={i18n}>{props.children}</I18nProvider>
}
